import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="relative py-12 md:py-16 px-6 md:px-10 lg:px-16 bg-background-100 border-t border-background-200/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          {/* Logo */}
          <a href="#hero" className="flex items-center gap-3 cursor-pointer">
            <Logo className="h-6 md:h-7 w-auto" />
          </a>


          {/* Copyright */}
          <p className="text-sm text-foreground-400">
            &copy; {new Date().getFullYear()} All rights reserved by DATAi Limited
          </p>
        </div>
      </div>
    </footer>
  );
}